import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLoader = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.75,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M12 2v4" }),
		/* @__PURE__ */ _jsx("path", { d: "m16.2 7.8 2.9-2.9" }),
		/* @__PURE__ */ _jsx("path", { d: "M18 12h4" }),
		/* @__PURE__ */ _jsx("path", { d: "m16.2 16.2 2.9 2.9" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 18v4" }),
		/* @__PURE__ */ _jsx("path", { d: "m4.9 19.1 2.9-2.9" }),
		/* @__PURE__ */ _jsx("path", { d: "M2 12h4" }),
		/* @__PURE__ */ _jsx("path", { d: "m4.9 4.9 2.9 2.9" })
	]
});
const ForwardRef = forwardRef(SvgLoader);
export default ForwardRef;
